import { render, staticRenderFns } from "./TheDrawer.vue?vue&type=template&id=0be40150&scoped=true"
import script from "./TheDrawer.vue?vue&type=script&lang=js"
export * from "./TheDrawer.vue?vue&type=script&lang=js"
import style0 from "./TheDrawer.vue?vue&type=style&index=0&id=0be40150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be40150",
  null
  
)

export default component.exports